"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PNG: 'png',
  JPEG: 'jpeg',
  JPG: 'jpg',
  MP4: 'mp4',
  MOV: 'mov',
  MPEG_4: 'mpeg-4'
};
exports.default = _default;